import styles from './Table.module.css';

export const Placeholder = () => {
  return (
    <div className={styles.placeholder}></div>
  );
}